import React from 'react';

import Bills from './Children/Bills';
import Configuration from './Children/Configuration';
import Dashboard from './Children/Dashboard';
import Reports from './Children/Reports';

// TODO: Add scopes
export const BillingConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'billingGroup',
      path: 'billing',
      children: [
        {
          id: 'billingGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          id: 'billingGroup.bills',
          path: 'bills',
          element: <Bills />,
        },
        {
          id: 'billingGroup.reports',
          path: 'reports',
          element: <Reports />,
        },
        {
          id: 'billingGroup.configuration',
          path: 'configuration',
          element: <Configuration />,
        },
      ],
    },
  ],
};
